import { cadastro_reordenamento_planejamento } from "./cadastro-reordenamento-planejamento";
import { realizar_copia_reordenamento } from "./realizar-copia-reordenamento";
import { relacao_reordenamento_sem_continuidade } from "./relacao-reordenamento-sem-continuidade";

const reordenamento_das_escolas = [
  cadastro_reordenamento_planejamento,
  realizar_copia_reordenamento,
  relacao_reordenamento_sem_continuidade,
];

export { reordenamento_das_escolas };
